var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStandards(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.07952 7.19225L8.7996 3.5253C9.2779 3.27021 9.85186 3.27021 10.3302 3.5253L17.9191 7.66257C18.1742 7.80606 18.3337 8.06913 18.3337 8.36408V13.4739C18.3337 13.9123 17.9749 14.271 17.5365 14.271C17.0981 14.271 16.7393 13.9123 16.7393 13.4739V8.76266L10.3302 12.2622C9.85186 12.5253 9.2779 12.5253 8.7996 12.2622L2.07952 8.59525C1.52948 8.29233 1.52948 7.49517 2.07952 7.19225ZM3.98463 13.0594V10.4287L8.79949 13.0594C9.27779 13.3224 9.85175 13.3224 10.33 13.0594L15.1449 10.4287V13.0594C15.1449 13.8565 13.1889 16.0886 9.60165 16.0886C6.01442 16.0886 3.98463 13.8565 3.98463 13.0594Z",
    fill: "#757575"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStandards);
export default __webpack_public_path__ + "static/media/standards.a0dae4ef.svg";
export { ForwardRef as ReactComponent };